import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Output } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getStepDetails } from 'visa-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import { map as map$1 } from 'rxjs/operators';
import * as i2 from 'ngx-toastr';

class APICreateTemplate {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getLetterType(visaType, caseType, caseId, letterType, superTaskId, taskId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${caseId}/letter/${letterType}?superTaskId=${superTaskId}&taskId=${taskId}`).pipe(map((response) => {
            if (response.status === 200 || response.status === 204) {
                return response;
            }
        }));
    }
    getAIGeneratedValue(searchQuery) {
        searchQuery = this.toEncrypt(searchQuery);
        return this.httpClient.get(`/getAiLetterTemplate/${searchQuery}`).pipe(map((response) => response));
    }
    postLetterType(visaType, caseType, caseId, superTaskId, taskId, payload) {
        return this.httpClient.post(`/${visaType}/${caseType}/${caseId}/letter/COVLTR?superTaskId=${superTaskId}&taskId=${taskId}`, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
APICreateTemplate.ɵfac = function APICreateTemplate_Factory(t) { return new (t || APICreateTemplate)(i0.ɵɵinject(i1.HttpClient)); };
APICreateTemplate.ɵprov = i0.ɵɵdefineInjectable({ token: APICreateTemplate, factory: APICreateTemplate.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APICreateTemplate, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

// import { FroalaEditorOptions } from 'editor-library';
class BaseCreateTemplateLibraryService {
    constructor(apiService, toast, store) {
        this.apiService = apiService;
        this.toast = toast;
        this.store = store;
        // public options = FroalaEditorOptions.EditorOptions;
        this.taskDetailsSubscription$ = new Subject();
        this.observableSubscription$ = new Subject();
        this.isAIGenerated = false;
        this.redirectionComponent = new EventEmitter();
        this.disabledControls = false;
        this.letterType = sessionStorage.getItem('typeOfLetter');
        this.template = {
            header: '',
            body: '',
            footer: ''
        };
    }
    loadInit() {
        if (sessionStorage.getItem('wizardTID')) {
            //this.getTemplateDetails();
        }
        else {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.typeOfButton = data.isPetitionerAction === 1 || data.isAttorneyAction === 1 ? "MARK_COMPLETE" : "MARK_SUBMIT";
                this.stepDetails = data;
                //this.getTemplateDetails();
            });
        }
    }
    ngAfterViewInit() {
        this.createTemplateForm.form.valueChanges.pipe(map$1(() => this.createTemplateForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    getTemplateDetails() {
        this.apiService.getLetterType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.letterType, this.inputData.superTaskId, this.inputData.subTaskId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.template = response && response.data ? response.data : {
                header: '', body: '',
                footer: ''
            };
        });
    }
    handleSaveTemplate() {
        let payload = {
            header: this.isAIGenerated ? '<p></p>' : this.template.header,
            body: this.isAIGenerated ? this.aiGeneratedValue : this.template.body,
            footer: this.isAIGenerated ? '<p></p>' : this.template.footer
        };
        this.apiService.postLetterType(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.inputData.superTaskId, this.inputData.subTaskId, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response.status === 200) {
                let test = 0;
                sessionStorage.setItem('documentTemplateId', (test).toString());
                this.toast.success(response.message, 'Success');
                this.aiGeneratedValue = null;
                this.createTemplateForm.resetForm(this.createTemplateForm.value);
                this.getTemplateDetails();
                this.redirectionComponent.emit('LetterPreview');
            }
        });
    }
    handleCancel() {
        this.getTemplateDetails();
    }
    handleBack() {
        this.redirectionComponent.emit('LetterTemplate');
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
BaseCreateTemplateLibraryService.ɵfac = function BaseCreateTemplateLibraryService_Factory(t) { return new (t || BaseCreateTemplateLibraryService)(i0.ɵɵinject(APICreateTemplate), i0.ɵɵinject(i2.ToastrService), i0.ɵɵinject(i3.Store)); };
BaseCreateTemplateLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseCreateTemplateLibraryService, factory: BaseCreateTemplateLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseCreateTemplateLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: APICreateTemplate }, { type: i2.ToastrService }, { type: i3.Store }]; }, { redirectionComponent: [{
            type: Output
        }] }); })();

/*
 * Public API Surface of base-create-template-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APICreateTemplate, BaseCreateTemplateLibraryService };
//# sourceMappingURL=base-create-template-library.js.map
